// 首页功能模块化配置
export class HModule {
  constructor(form) {
    if (form) {
      this.bannerOne = Array.isArray(form.bannerOne) && form.bannerOne.length ? form.bannerOne : [{ title: '', linkUrl: '', imageUrl: '' }] || [{ title: '', linkUrl: '', imageUrl: '' }];
      this.bannerThree = Array.isArray(form.bannerThree) && form.bannerThree.length ? form.bannerThree : [{ title: '', linkUrl: '', imageUrl: '' }] || [{ title: '', linkUrl: '', imageUrl: '' }];
    } else {
      this.clear();
    }
  }

  clear() {
    this.bannerOne = [{ title: '', linkUrl: '', imageUrl: '' }];
    this.bannerThree = [{ title: '', linkUrl: '', imageUrl: '' }];
  }
}
